import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../../services/apiClient";

const ChapterDetailEdit = () => {
  const { chapterId } = useParams();
  const [chapter, setChapter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchChapter = async () => {
      try {
        const response = await apiClient.get(`/api/admin/chapters/${chapterId}`);
        setChapter(response.data);
        setTitle(response.data.title);
        setContent(response.data.content);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching chapter:", error);
        setLoading(false);
      }
    };

    fetchChapter();
  }, [chapterId]);

  const handleUpdateChapter = async () => {
    try {
      await apiClient.put(`/api/admin/chapters/${chapterId}`, { title, content });
      navigate(`/admin/stories/${chapter.story_id}/detail`);
    } catch (error) {
      console.error("Error updating chapter:", error);
    }
  };

  const handleDeleteChapter = async () => {
    try {
      await apiClient.delete(`/api/admin/chapters/${chapterId}`);
      navigate(`/admin/stories/${chapter.story_id}/detail`);
    } catch (error) {
      console.error("Error deleting chapter:", error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Edit Chapter</h1>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Chapter Title"
        className="border p-2 mb-2 w-full"
      />
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Chapter Content"
        className="border p-2 mb-2 w-full"
        rows="10"
      />
      <div className="flex justify-between">  
        <button onClick={handleUpdateChapter} className="bg-blue-500 text-white p-2 rounded">
          Update Chapter
        </button>
        <button onClick={handleDeleteChapter} className="bg-red-500 text-white p-2 rounded">Delete Chapter</button>
      </div>
    </div>
  );
};

export default ChapterDetailEdit;
